import { Button, CircularProgress, Grid, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useEffect, useMemo, useState } from 'react';
import { PaperCard } from '../Cards/styles';
import { EducationXGrid } from './EducationXGrid';
import { useDispatch, useSelector } from 'react-redux';
import { candidateEducationSelection, educationActiveSelection } from '../../../Profile/CandidateDetails.selector';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import { candidateDetailActions } from '../../../Profile/CandidateDetails.redux';
import { AddEducationDialog } from '../../Common/AddEducationDialog';
import { AddTagsIcon } from '@AMIEWEB/Candidate/CandidateProfile/CandidateHeader/TagsWrapper/AddTagsIcon';
import { Add } from '@mui/icons-material';

const useStyles = makeStyles()({
  gridTitle: {
    marginTop: '2px',
  },
  addEducationLinkGrid: {
    display: 'inline-flex',
    justifyContent: 'flex-end',
  },
  profileInlineLink: {
    color: '#006FB9',
    'font-weight': '800',
    'padding-left': '0.3rem',
    'text-decoration': 'underline',
    cursor: 'pointer',
  },
  addIcon: {
    height: '24px',
    width: '24px',
    padding: '0px 5px 8px 0px',
  },
});
export const EducationWrapper = props => {
  const education = useSelector(candidateEducationSelection);
  const isEduActive = useSelector(educationActiveSelection);
  const [loading, setLoading] = useState<boolean>(true);
  const { classes } = useStyles();
  const [openAddPop, setOpenAddPop] = useState<boolean>(false);
  const dispatch = useDispatch();

  const Loading = () => (
    <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'center' }}>
      <CircularProgress />
    </div>
  );

  useEffect(() => {
    setLoading(props.loading);
  }, [props.loading]);

  const handleNavigation = () => {
    setOpenAddPop(true);
  };
  const handleClose = () => {
    setOpenAddPop(false);
  };

  const EduXGrid = useMemo(() => {
    return (
      <>
        {loading ? (
          <Loading />
        ) : (
          <LayoutGridItem item xs={12}>
            {education && <EducationXGrid rows={education} />}
          </LayoutGridItem>
        )}
      </>
    );
  }, [education, loading]);

  return (
    <PaperCard elevation={0}>
      <Grid container style={{ paddingBottom: '12px', width: '100%' }}>
        <Grid item style={{ display: 'flex' }} xs={2}>
          <ArrowBackIcon
            onClick={e => {
              props.handleToggle(e);
              if (isEduActive) {
                window.history.pushState(null, '', `${window.location.pathname}?tab=0`);
                dispatch(candidateDetailActions.setEducationActive(false));
              }
            }}
            style={{ cursor: 'pointer' }}
          />
          <Typography variant="subtitle2" gutterBottom className={classes.gridTitle}>{`Education`}</Typography>
        </Grid>
        <Grid item xs={10} className={classes.addEducationLinkGrid}>
          <Button
            variant="iconText"
            color="primary"
            onClick={() => {
              handleNavigation();
            }}
            startIcon={<Add className={classes.addIcon} />}
          >
            <Typography>Add Education</Typography>
          </Button>
        </Grid>
        {openAddPop && <AddEducationDialog open={openAddPop} handleClose={handleClose} />}
      </Grid>
      <LayoutGrid>
        <LayoutGridItem xs={12}>{EduXGrid}</LayoutGridItem>
      </LayoutGrid>
    </PaperCard>
  );
};
